// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function ShippingInfo(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'ShippingInfo',
      'aria-hidden': true,
      focusable: false,
      width: 44 * scale,
      height: 38 * scale,
      viewBox: '0 0 44 38',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement(
      'g',
      {stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd'},
      createElement('path', {
        d: 'M0 0h44v38H0V0zm1 1v36h42V1H1z',
        fillOpacity: '.4',
        fill: '#000',
      }),
      createElement('path', {
        fillOpacity: '.2',
        fill: '#D9D9D9',
        d: 'M1 1h42v36H1z',
      }),
      createElement('path', {
        d: 'M41 12V8h2v4h-2zm0 2h2v4h-2v-4zm0 6h2v4h-2v-4zm0 6h2v4h-2v-4zm0 6h2v5h-5v-2h3v-3zm-5 3v2h-4v-2h4zm-6 0v2h-4v-2h4zm-6 0v2h-4v-2h4zm-6 0v2h-4v-2h4zm-6 0v2H8v-2h4zm-6 0v2H1v-5h2v3h3zm-3-5H1v-4h2v4zm0-6H1v-4h2v4zm0-6H1v-4h2v4zm0-6H1V8h2v4zm0-6H1V1h5v2H3v3zm5-3V1h4v2H8zm6 0V1h4v2h-4zm6 0V1h4v2h-4zm6 0V1h4v2h-4zm6 0V1h4v2h-4zm6 0V1h5v5h-2V3h-3zm-15 7h4l4 5h-8v-5zm-2 0v5h-8l4-5h4zm10 7v11H13V17h18zm-9 1l-3.5 5H21v3h2v-3h2.5L22 18z',
        fill: '#D9D9D9',
      })
    )
  );
}
